<script lang="ts">
	import { format } from 'svelte-i18n';
	import { alarms } from 'src/stores/lists/scenes-derived';
	import { is_automation_condition_ui } from '../../../../../../../../types/AutomationConditionUI';
	import { navigateToShop, sortByPosition } from '../../../../../../../Lists/list-helpers';
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import { WHEN_WIZARD_STEPS_INDEXES } from '../../helpers/when-wizard-helpers';
	import EmptyList from 'src/components/Lists/EmptyList.svelte';
	import { capFirstChar } from 'src/helpers/utilities';

	export let sceneData: any;
	export let firstSelectedRef: HTMLElement = null;

	const setSelectedSortedAlarms = () => {
		return Object.values($alarms)
			.sort(sortByPosition)
			.map((alarm) => {
				return {
					id: alarm._id,
					value: alarm._id,
					title: alarm._meta.name,
					name: alarm._meta.name,
					image: alarm._meta.image,
					backgroundColor: alarm._meta.backgroundColor,
					selected: sceneData._automation_condition.scene_id == alarm._id,
				};
			});
	};

	let sortedAlarms = setSelectedSortedAlarms();

	if (is_automation_condition_ui(sceneData.translated)) {
		//find selected automation
		//find room if it is a scene
		//find selected item
		sceneData._automation_condition = {
			scene_id: sceneData.translated.scene_id,
			selected: true,
		};

		sortedAlarms = setSelectedSortedAlarms();
	}

	// $: {
	// 	sceneData.isValid =
	// 		sceneData._automation_condition.scene_id !== '' &&
	// 		sceneData._automation_condition.selected;
	// }

	const validateWizardAlarmSelect = () => {
		sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.DEVICE_PROPS_STEP;
		sceneData.isValid = true;
	};

	const onSelectScene = (alarm) => {
		validateWizardAlarmSelect();

		sceneData._automation_condition.scene_id = alarm.value;
		sceneData._automation_condition.selected = alarm.value !== undefined;

		sortedAlarms = sortedAlarms.map((a) => {
			let selected = false;
			if (a.id === alarm.id) {
				selected = true;
			}

			return {
				...a,
				selected,
			};
		});
	};
</script>

<SelectList
	class="mb-s"
	title={$format('label_select_alarm', {
		default: 'Select alarm',
	})}
	list={sortedAlarms}
	variant="radio"
	on:click={(e) => onSelectScene(e.detail)}
	bind:firstSelectedRef
/>

{#if !sortedAlarms.length}
	<div class="d-flex flex-direction-column justify-content-center align-items-center mt-s">
		<EmptyList
			withoutMargin
			type="modal"
			title={$format('on_board_get_device_title', {
				default: 'Get the necessary devices to set up.',
			})}
			description={$format('on_board_get_device_description', {
				default:
					'Currently you don’t have the necessary devices. Please get the necessary devices to set up your automations.',
			})}
			btnText={capFirstChar(
				$format('button_go_to_store', {
					default: 'Go to store',
				}).toLocaleLowerCase(),
			)}
			onClick={() => {
				navigateToShop();
			}}
		/>
	</div>
{/if}
